/**
 * Interpolates between two distortion points
 * @param {Object} a - First point {x, y}
 * @param {Object} b - Second point {x, y}
 * @param {number} blend - Blend factor (0-1)
 * @returns {Object} Interpolated point {x, y}
 */
export const interpolateDistortions = (a, b, blend) => {
  return {
    x: b?.x * (1 - blend) + a?.x * blend,
    y: b?.y * (1 - blend) + a?.y * blend
  };
};
